<script>
import resources from './resources'

export default {
  name: 'professional-rules-form',

  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Regras para Agenda Profissional", icon="")
    modal(:visible="showModal", :closeVisible="false",)
      Schedules(
        v-if="showModal",
        :data="schedules",
        :title="' - ' +agendaTitle+ '<br>Selecione os horários que deseja remover:'",
        :rule="rule",
        @locked="closeModal")

        //-- modal(:visible="showModalPreview")
        //-- preview(v-if="showModalPreview", :data="schedules", :title="' - ' +agendaTitle+ '<br>Selecione os horários que deseja bloquear:'", @locked="closeModal")

    .col-xs-12.content
      .container-fluid
        .row
          medibook-alert-custom-slot(
            :show='show',
            @close='show = false',
            title='Perfeito',
            type='sa-success',
            message='Regra incluida com sucesso.',
            v-if="wasRaised")
              button.btn.find-filled.btn-margin-alert(@click.prevent="doPreview()")
                span.icon 
                |  Pré Visualizar Agenda

              button.btn.find-filled.btn-margin-alert(@click.prevent="gotToLock()")
                span.icon 
                |  Novo Bloqueio

              button.btn.find-filled.btn-margin-alert(@click.prevent="newRule()")
                span.icon 
                |  Nova Regra

          medibook-alert-custom-slot(
            :show='show',
            @close='show = false',
            title='Perfeito',
            type='sa-success',
            message='Regra alterada com sucesso.',
            v-if="beenUpdated")
              button.btn.find-filled.btn-margin-alert(@click.prevent="doPublish()")
                span.icon 
                |  Publicar

              button.btn.find-filled.btn-margin-alert(@click.prevent="gotToLock()")
                span.icon 
                |  Incluir novo Bloqueio

          ul.nav.nav-tabs
            li
              router-link(:to="{ name: 'professional.agenda.rules.index'}")
               a(href="#") Listagem
            li.active
               a(href="#") Cadastro
          .col-xs-12.white-bg
            .row
              .col-xs-12
                form.col-sm-10
                  h4 AGENDA PROFISSIONAL — REGRAS
                  .form-group
                    .row
                      .col-xs-12
                        // :disabled="!(!rule.id)",
                        v-input(:status="$v.rule.agenda_id.$error ? 'error' : null")
                          f-select-professional-agenda(label="Agenda Médica",
                            name="agenda_id",
                            v-model="rule.agenda_id",
                            :searchable="true",
                            :get-all="true",
                            :disabled="!(!rule.published)",
                            :errors="errors['agenda_id']")

                  .form-group
                    .row
                      .col-xs-12.col-sm-4.margin-bottom
                        v-input(:status="$v.rule.interval.$error ? 'error' : null")
                          f-select(label="Intervalo",
                            name="interval",
                            v-model="rule.interval",
                            :options="intervalOptions",
                            :searchable="true",
                            :disabled="!(!rule.published)",
                            :errors="errors['interval']")

                      .col-xs-12.col-sm-4.margin-bottom
                        v-input(:status="$v.rule.valid_to_start.$error ? 'error' : null")
                            label Validade Inicial
                            //- Insert
                            v-datepicker(
                              v-if="rule.id === null",
                              name="valid_to_start",
                              v-model="rule.valid_to_start",
                              :config='config',
                              )

                            //- Edit
                            v-datepicker(
                              v-if="rule.id !== null",
                              name="valid_to_start",
                              v-model="rule.valid_to_start",
                              :config='configEdit',
                              :disabled="!(!rule.published)"
                              )

                            //- f-date(
                              label="Validade Inicial",
                              v-model="rule.valid_to_start"
                              :date="rule.valid_to_start",
                              :disabled="!(!rule.published)",
                              :errors="errors['valid_to_start']")

                      .col-xs-12.col-sm-4.margin-bottom
                        v-input(:status="$v.rule.valid_to_end.$error ? 'error' : null")
                          label Validade Final

                          //- Insert
                          v-datepicker(
                            v-if="rule.id === null",
                            name="valid_to_end",
                            v-model="rule.valid_to_end",
                            :config='config'
                            )
                          //- Edit
                          v-datepicker(
                            v-if="rule.id !== null",
                            name="valid_to_end",
                            v-model="rule.valid_to_end",
                            :config='configEdit',
                            :disabled="!(!rule.published)"
                            )

                          //- f-date(
                            label="Validade Final",
                            v-model="rule.valid_to_end"
                            :date="rule.valid_to_end",
                            :disabled="!(!rule.published)",
                            :errors="errors['valid_to_end']")

                  .row.border-bottom
                  .form-group(style='margin-top:15px;')
                    .row
                      .col-xs-12
                        label Dias da Semana
                      .col-xs-3.col-sm-2.col-md-1.margin-bottom
                        .checkbox
                          label
                            input.check(type='checkbox', name="sunday" v-model='rule.sunday', :disabled="!(!rule.published)")
                            |  Dom
                      .col-xs-3.col-sm-2.col-md-1.margin-bottom
                        .checkbox
                          label
                            input.check(type='checkbox', name='monday' v-model='rule.monday', :disabled="!(!rule.published)")
                            |  Seg
                      .col-xs-3.col-sm-2.col-md-1.margin-bottom
                        .checkbox
                          label
                            input.check(type='checkbox', name='tuesday' v-model='rule.tuesday', :disabled="!(!rule.published)",)
                            |  Ter
                      .col-xs-3.col-sm-2.col-md-1.margin-bottom
                        .checkbox
                          label
                            input.check(type='checkbox', name='wednesday' v-model='rule.wednesday', :disabled="!(!rule.published)",)
                            |  Qua
                      .col-xs-3.col-sm-2.col-md-1.margin-bottom
                        .checkbox
                          label
                            input.check(type='checkbox', name='thursday' v-model='rule.thursday', :disabled="!(!rule.published)",)
                            |  Qui
                      .col-xs-3.col-sm-2.col-md-1.margin-bottom
                        .checkbox
                          label
                            input.check(type='checkbox', name='friday' v-model='rule.friday', :disabled="!(!rule.published)",)
                            |  Sex
                      .col-xs-3.col-sm-2.col-md-1.margin-bottom
                        .checkbox
                          label
                            input.check(type='checkbox', name='saturday' v-model='rule.saturday', :disabled="!(!rule.published)",)
                            |  Sáb
                  .row.border-bottom
                  .form-group(style='margin-top:15px;')
                    .row
                      .col-xs-12.col-sm-6.margin-bottom
                        label Primeiro Período
                        .row
                        .col-xs-6(style='padding-left:0px;padding-top:5px;', v-if="!rule.published")
                          f-time(label="Hora Inicial"
                            name="time_start",
                            v-model="rule.time_start",
                            :errors="errors['time_start']",
                            :disabled="!(!rule.published)",
                            placeholder="00:00")
                        .col-xs-6(style='padding-left:0px;padding-top:5px;', v-if="!(!rule.published)")
                          label Hora Inicial
                          .input.form-control(disabled="disabled")
                            | {{ rule.time_start }}

                        .col-xs-6(style='padding-left:0px;padding-top:5px;', v-if="!rule.published")
                          f-time(label="Hora Final"
                            name="time_end",
                            v-model="rule.time_end",
                            :errors="errors['time_end']",
                            placeholder="00:00")
                        .col-xs-6(style='padding-left:0px;padding-top:5px;', v-if="!(!rule.published)")
                          label Hora Final
                          .input.form-control(disabled="disabled")
                            | {{ rule.time_end }}

                      .col-xs-12.col-sm-6.margin-bottom
                        label Segundo Período
                        .row
                        .col-xs-6(style='padding-left:0px;padding-top:5px;', v-if="!rule.published")
                          f-time(label="Hora Inicial"
                            name="time_start_two",
                            v-model="rule.time_start_two",
                            :errors="errors['time_start_two']"
                            placeholder="00:00")
                        .col-xs-6(style='padding-left:0px;padding-top:5px;', v-if="!(!rule.published)")
                          label Hora Inicial
                          .input.form-control(disabled="disabled")
                            | {{ rule.time_start_two }}

                        .col-xs-6(style='padding-left:0px;padding-top:5px;', v-if="!rule.published")
                          f-time(label="Hora Final"
                            name="time_end_two",
                            v-model="rule.time_end_two",
                            :errors="errors['time_end_two']"
                            placeholder="00:00")
                        .col-xs-6(style='padding-left:0px;padding-top:5px;', v-if="!(!rule.published)")
                          label Hora Final
                          .input.form-control(disabled="disabled")
                            | {{ rule.time_end_two }}

                  .row(v-if="countSchedulings()")
                    .alert.alert-danger
                      strong Identificamos um processo de publicação iniciado. &nbsp;
                      | Visualize os registros clicando em
                      strong  Pré-Visualização.

                  .buttons-wrapper
                    //- button.btn.find-filled.btn-margin-alert(v-if="allowPublish", @click.prevent="gotNextPreview()")
                    //- span.icon 
                    //- |  Prè visualização

                    //- Botão após o cancelamento total pelo preview
                    button.btn.find-filled.btn-margin-alert(@click.prevent="doPreview()", :disabled="publishing", v-if="cancelOnPreview")
                      span.icon 
                      |  Pré Visualizar Agenda

                    //- botão cancelamento em edição
                    button.btn.find-filled.btn-margin-alert(@click.prevent="doPreview()", :disabled="publishing", v-if="!rule.published && rule.id && !cancelOnPreview && !publishedOnPreview")
                      span.icon 
                      |  Pré Visualizar Agenda

                    //-button.btn.find-filled.btn-margin-alert(v-if="allowPublish && cancelOnPreview", @click.prevent="doPublish()", :disabled="publishing")
                      span.icon 
                      |  Publicar

                    //- Fazer processo para cancelar
                    button.btn.cancel(v-if="rule.published || publishedOnPreview", @click.prevent="doRollBackuPublish(rule)")
                      span.icon 
                      |  Cancelar Publicação

                    button.btn.cancel(v-if="rule.preview", @click.prevent="doRollBackuPublish(rule)")
                      span.icon 
                      | Cancelar Previsualização

                    button.btn.save(v-if="!rule.published && !publishedOnPreview ", @click.prevent="doSave()", :disabled="rule.published || disabledSave || publishedOnPreview || publishing || countSchedulings()")
                      span.icon 
                      |  Salvar Alterações

</template>
<style scoped>
  .alert-danger {
      color: #a94442;
      background-color: #f2dede;
      border-color: #ebccd1;
  }
  .alert {
      padding: 15px;
      margin-bottom: 20px;
      border: 1px solid transparent;
      border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/app/professional/agenda/rules/form/form.vue